import httpClient from './http-clients';

export const createPaystackOrder = async (data) => {
  const response = await httpClient.post('orders/create-paystack-order', data);
  return response.data;
};

export const validateFullOrDownPayment = async (reference) => {
  const response = await httpClient.post('orders/validate-paystack-payment', {
    reference,
  });
  return response.data.data;
};

export const initializeBalancePayment = async (orderID) => {
  const response = await httpClient.post(
    'orders/initialize-balance-payment',
    { orderID }
  );
  return response.data;
};

export const validateBalancePayment = async ({ reference, orderID }) => {
  const response = await httpClient.post('orders/validate-paystack-payment', {
    reference,
    orderID,
  });
  return response.data.data;
};

// export const payInFull = async (data) => {
//   const response = await httpClient.post('orders/create-paystack-order', data);
//   return response.data;
// };

export const createPaystackMandate = async (data) => {
  const response = await httpClient.post(
    'orders/create-paystack-mandate',
    data
  );
  return response.data;
};

export const getOrderDetails = async (orderId) => {
  const response = await httpClient.get(`/orders/get-single-order/${orderId}`);
  return response.data;
};

export const getAllOrders = async () => {
  const response = await httpClient.get(
    'orders/get-all-orders?page=1&per_page=100'
  );
  return response.data.data;
};

export const getAllLinkedAccounts = async () => {
  const response = await httpClient.get('payment/get-buyer-active-mandate');
  return response.data.data;
};

export const extendBuyingCredit = async () => {
  const response = await httpClient.post('auth/send-verification-email');
  return response.data;
};

export const submitHRDetails = async (data) => {
  const response = await httpClient.post('orders/submit-employer-info', data);
  return response.data;
};

export const getDeliveryFee = async () => {
  const response = await httpClient.get('orders/get-delivery-fee');
  return response.data;
};
